<!-- PROGRESS BAR -->
<fuse-progress-bar></fuse-progress-bar>
<!-- / PROGRESS BAR -->

<router-outlet></router-outlet>
<div id="app_mask" *ngIf="pageLoaderService.isLoading"> <div></div> </div>

<ng-container>
    <main-layout class="main-ang-layout"></main-layout>
</ng-container>